<template>
  <div>
    <router-link
      :to="{ name: 'History', params: { previousPage: previousPage } }"
      ><i class="fas fa-long-arrow-alt-left"></i> Powrót do zamówień
    </router-link>
    <history-progress-steps
      v-if="Object.keys(order).length !== 0"
      :order="order"
      accountantAdd="false"
      skpAdd="false"
    ></history-progress-steps>
    <h6 class="my-2 font-weight-bold" v-html="cloudName(orderName)"></h6>
    <b-row class="my-1">
      <b-col lg="auto" v-if="staffName">
        <b-form-group
          class="font-weight-bold"
          label-cols-lg="auto"
          label="Przyjęte przez"
          label-for="lic"
        >
          <b-form-input
            id="lic"
            v-model="order.ZAMOW_KTO"
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="auto" v-if="staffName">
        <b-form-group
          class="font-weight-bold"
          label-cols-lg="auto"
          label="Forma zamówienia"
          label-for="lic"
        >
          <b-form-input id="lic" v-model="source" disabled></b-form-input>
        </b-form-group>
      </b-col>
      <b-col lg="auto">
        <b-form-group
          class="font-weight-bold"
          label-cols-lg="auto"
          label="Data zamówienia"
          label-for="lic"
        >
          <b-form-input id="lic" v-model="order.DATA" disabled></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <order-details
      :order="order"
      :products="products"
      :paymentType="paymentType"
      :invoiceData="invoiceData"
      :invoice="invoice"
      :proformaInvoice="proformaInvoice"
      :discountRecommendation="discountRecommendation"
      :statusDescription="statusDescription"
    ></order-details>
    <p v-if="order.statement_file" class="ml-1">
      <b-button @click="getStatementDownload" variant="link" class="p-0 m-0"
        >Pobierz oświadczenie <i class="fas fa-arrow-down py-0"></i
      ></b-button>
      <span v-if="fileError" class="small text-danger"
        >Nie znaleziono pliku.</span
      >
    </p>
    <b-card-text
      v-if="orderPayu && order.deleted_at === null"
      v-html="orderPayu"
      class="text-center mt-3 mb-1"
    ></b-card-text>
    <b-card-text v-if="orderCanBeRemoved" class="text-center">
      <b-button
        class="my-2 ml-auto mb-2 align-items-center"
        @click="confirmRemove"
        >Usuń to zamówienie i złóż nowe
      </b-button>
    </b-card-text>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OrderDetails from './OrderDetails';
import HistoryProgressSteps from './HistoryProgressSteps';

export default {
  name: 'ShowOrder',
  components: { OrderDetails, HistoryProgressSteps },
  data() {
    return {
      id: '',
      order: {
        PL: '',
        STATUS_PL: '',
        NETTO: 0,
      },
      products: [],
      fields: [
        { key: 'name', label: 'Nazwa' },
        { key: 'ilosc', label: 'Ilość' },
        { key: 'netto', label: 'Cena netto' },
        { key: 'vat', label: 'VAT' },
        { key: 'brutto', label: 'Cena brutto' },
      ],
      paymentType: '',
      orderName: '',
      invoiceData: null,
      invoice: null,
      proformaInvoice: null,
      discountRecommendation: null,
      orderPayu: null,
      statementFile: null,
      fileError: false,
      statusDescription: null,
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      licence: 'auth/userLicence',
      client: 'auth/client',
    }),
    staffName() {
      return localStorage.getItem('staffName');
    },
    payuActive() {
      if (
        this.paymentType === 'PayU (przelew/karta)' &&
        this.order.STATUS_PL <= 3 &&
        this.order.NETTO > 0
      ) {
        return true;
      }
      return false;
    },
    source() {
      switch (this.order.ZAMOW_SKAD) {
        case 'te':
          return 'Telefonicznie';
        case 'os':
          return 'Osobiście';
        case 'fa':
          return 'Faksem';
        case 'ma':
          return 'Mailem';
        case 'po':
          return 'Poczta';
        case 'in':
          return 'Inne';
        default:
          return '';
      }
    },
    orderCanBeRemoved() {
      return (
        this.order.STATUS_PL === 0 &&
        (this.order.PL === null ||
          (this.order.PL && !this.order.PL.includes('POBRANIE'))) &&
        this.order.deleted_at === null
      );
    },
    previousPage() {
      return this.$route.params.previousPage;
    },
  },
  created() {
    this.id = this.$route.params.id;
    this.getOrder();
    this.type = this.paymentType;
  },
  methods: {
    getOrder() {
      axios
        .get('/api/getOrder/' + this.program + '/' + this.id)
        .then(({ data }) => {
          this.order = data.order;
          this.invoice = data.invoice;
          this.proformaInvoice = data.proformaInvoice;
          this.products = data.products;
          this.paymentType = data.paymentType;
          this.orderName = data.orderName;
          this.invoiceData = data.invoiceData;
          this.discountRecommendation = data.discountRecommendation;
          this.statusDescription = data.status_description;
          this.getOrderPayu();
        })
        .catch((error) => {
          // console.log(error);
        });
    },
    getStatementDownload() {
      this.fileError = false;
      axios
        .get('/api/getStatementFile/' + this.program + '/' + this.id + '/zam', {
          responseType: 'arraybuffer',
        })
        .then((response) => {
          let blob = new Blob([response.data], { type: 'application/pdf' });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.order.statement_file;
          link.click();
        })
        .catch((error) => {
          this.fileError = true;
        });
    },
    getOrderPayu() {
      axios
        .get('/api/orderWithPayu/' + this.program + '/' + this.id + '/zam')
        .then(({ data }) => {
          this.orderPayu = data;
        });
    },
    confirmRemove() {
      this.$bvModal
        .msgBoxConfirm('Czy na pewno chcesz usunąć zamówienie?', {
          title: '',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'Usuń',
          cancelTitle: 'Anuluj',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxOne = value;
          if (value) {
            this.removeOrder();
          }
        });
    },
    removeOrder() {
      let data = {
        order: this.order,
        program: this.program,
      };
      axios.post('/api/removeOrder', data).then((response) => {
        this.$router.push({ name: 'History' });
      });
    },
    commaFormat(value) {
      return Number(value).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    cloudName(name) {
      if (name === 'Chmura') {
        return this.client.MDS !== null &&
          this.client.MDS !== '' &&
          this.client.MDS.split('').includes('B')
          ? 'Zamówienie - ' + this.program.toUpperCase() + '24 Connect Biuro'
          : this.program === 'skp'
          ? 'Zamówienie - SKP24 Connect Firma'
          : 'Zamówienie - SAM<sup>®</sup> Firma w Chmurze';
      }

      return name;
    },
  },
};
</script>

<style scoped></style>
